export enum NotificationType {
    Info = 'info',
    Success = 'success',
    Danger = 'danger',
    Warning = 'warning',
  }
  